import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { SupportedLocale } from '~/types/localization'
import type { AuthArgs } from '~/api/models/index'

const queries = {
  getByLocaleKey: {
    queryFn: (args: Ref<SupportedLocale>) => {
      return useApi().localization.getLocalizationsByLang(args.value)
    },
    queryKey: (args: Ref<SupportedLocale>) => ['localizations', args.value]
  }
} as const
const mutations = {
  // Mutations for creating, updating, and deleting locales
} as const

export type LocalizationService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): LocalizationService =>
  defineService(authArgs, {
    queries,
    mutations
  })
